// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"numbers-1"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M10 5L11 5C11.5523 5 12 5.44798 12 6.00026L12 19M12 19H10M12 19H14","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Numbers1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'numbers-1',
    ref,
    icon: element,
  },
));

Numbers1Icon.displayName = 'Numbers1Icon';

export default Numbers1Icon;
